"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useArbitrageFeeRateDisplay = exports.useArbitrageFundingFeeRate = exports.useArbitrageFundingFeeRateHistories = exports.getFundingFeeRateHistoriesOb = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const operators_1 = require("rxjs/operators");
const FutureUtils_1 = require("../CommonUtils/FutureUtils/FutureUtils");
const trade_quotation_lib_1 = require("trade_quotation_lib");
const getFundingFeeRateHistoriesOb = (isCM) => {
    const feeRatePublish$ = isCM ? trade_quotation_lib_1.CMFundingRatePublish$ : trade_quotation_lib_1.FundingRatePublish$;
    return feeRatePublish$.pipe((0, operators_1.filter)((e) => e && e.length > 0), (0, operators_1.map)((rates) => {
        const newResult = [];
        (rates || []).forEach((rate) => {
            if (rate.base === "DEFI") {
                return;
            }
            // 单次平均值, 转换为年化值.
            const timesPerDay = 3;
            const daysPerYear = 365;
            const newValue = Object.assign(Object.assign({}, rate), { average_1day: new trade_utils_lib_1.SafeDecimal(rate.average_1day).mul(timesPerDay).mul(daysPerYear).toString(), average_7days: new trade_utils_lib_1.SafeDecimal(rate.average_7days).mul(timesPerDay).mul(daysPerYear).toString(), average_30days: new trade_utils_lib_1.SafeDecimal(rate.average_30days).mul(timesPerDay).mul(daysPerYear).toString(), average_180days: new trade_utils_lib_1.SafeDecimal(rate.average_180days).mul(timesPerDay).mul(daysPerYear).toString() });
            newResult.push(newValue);
        });
        return newResult;
    }));
};
exports.getFundingFeeRateHistoriesOb = getFundingFeeRateHistoriesOb;
// spot symbol: example => BTC/USDT
const useArbitrageFundingFeeRateHistories = (orderType, symbol, leverage, repeat, focus = true) => {
    const [oriRate, setOriRate] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (orderType !== TradeAPILib_1.ExchangeOrderType.fsa && orderType !== TradeAPILib_1.ExchangeOrderType.cm_fsa) {
            setOriRate([]);
            return;
        }
        if (!focus) {
            return;
        }
        const feeRate$ = (0, exports.getFundingFeeRateHistoriesOb)(orderType === TradeAPILib_1.ExchangeOrderType.cm_fsa);
        let ob = feeRate$;
        if (!repeat) {
            ob = feeRate$.pipe((0, operators_1.take)(1));
        }
        const sub = ob.subscribe({
            next: (data) => {
                setOriRate(data);
            },
            error: (error) => {
                setOriRate([]);
            }
        });
        return () => {
            sub.unsubscribe();
        };
    }, [repeat, focus]);
    const calRateHistory = (0, react_1.useCallback)((rate, leverage) => {
        if (!rate || !leverage) {
            return rate;
        }
        const leverageD = new trade_utils_lib_1.SafeDecimal(leverage);
        const multiplier = leverageD.div(leverageD.add(1));
        return new trade_utils_lib_1.SafeDecimal(rate).mul(multiplier).toString();
    }, []);
    const filterSymbolRates = (0, react_1.useMemo)(() => {
        if (symbol) {
            return oriRate.filter((item) => {
                return item.symbol === symbol;
            });
        }
        return oriRate;
    }, [oriRate, symbol]);
    return (0, react_1.useMemo)(() => {
        if (leverage) {
            return filterSymbolRates.map((rate) => {
                return Object.assign(Object.assign({}, rate), { average_1day: calRateHistory(rate.average_1day || "", leverage || "1"), average_7days: calRateHistory(rate.average_7days || "", leverage || "1"), average_30days: calRateHistory(rate.average_30days || "", leverage || "1"), average_180days: calRateHistory(rate.average_180days || "", leverage || "1") });
            });
        }
        return filterSymbolRates;
    }, [filterSymbolRates, leverage]);
};
exports.useArbitrageFundingFeeRateHistories = useArbitrageFundingFeeRateHistories;
const useArbitrageFundingFeeRate = (isCM, symbol, leverage, repeat, focus = true) => {
    const orderType = isCM ? TradeAPILib_1.ExchangeOrderType.cm_fsa : TradeAPILib_1.ExchangeOrderType.fsa;
    return (0, exports.useArbitrageFundingFeeRateHistories)(orderType, symbol, leverage, repeat, focus);
};
exports.useArbitrageFundingFeeRate = useArbitrageFundingFeeRate;
const useArbitrageFeeRateDisplay = (isSwap, isCM, symbol, leverage, repeat, focus = true) => {
    // 不是合约的时候传入限价单, 进行不请求操作
    const orderType = isSwap ? (isCM ? TradeAPILib_1.ExchangeOrderType.cm_fsa : TradeAPILib_1.ExchangeOrderType.fsa) : TradeAPILib_1.ExchangeOrderType.limit;
    const fundingFeeRateHistories = (0, exports.useArbitrageFundingFeeRateHistories)(orderType, symbol, leverage, repeat, focus);
    const fundingFeeRateHistory = fundingFeeRateHistories.length && symbol ? fundingFeeRateHistories[0] : undefined;
    const fundingCountDown = (0, FutureUtils_1.useFundingRateCountDown)(fundingFeeRateHistory === null || fundingFeeRateHistory === void 0 ? void 0 : fundingFeeRateHistory.next_funding_fee_time, focus);
    return (0, react_1.useMemo)(() => {
        const rate = fundingFeeRateHistory === null || fundingFeeRateHistory === void 0 ? void 0 : fundingFeeRateHistory.last_funding_fee_rate;
        const rateStr = rate ? trade_utils_lib_1.NumberCommonUtils.toPercent(new trade_utils_lib_1.SafeDecimal(rate).mul(100), false, true, 4) : "--";
        return `${rateStr} / ${fundingCountDown}`;
    }, [fundingCountDown, fundingFeeRateHistory === null || fundingFeeRateHistory === void 0 ? void 0 : fundingFeeRateHistory.last_funding_fee_rate]);
};
exports.useArbitrageFeeRateDisplay = useArbitrageFeeRateDisplay;
